package br.com.htms.inspeccaocampo.web

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.CanvasBasedWindow
import br.com.htms.inspeccaocampo.platform.PlatformFiles
import br.com.htms.inspeccaocampo.ui.SharedAppRoot
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.launch
import org.jetbrains.skiko.wasm.onWasmReady

/**
 * Entrada da versão web — não altera Android/iOS.
 * Carrega cache IndexedDB (fotos/rascunho) antes de abrir a UI.
 */
@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    onWasmReady {
        GlobalScope.launch {
            runCatching { PlatformFiles.warmUp() }
                .onFailure { println("PlatformFiles.warmUp failed: ${it.message}") }
            try {
                CanvasBasedWindow(
                    canvasElementId = "ComposeTarget",
                    title = "Portal QSSMA"
                ) {
                    SharedAppRoot()
                }
            } catch (t: Throwable) {
                println("CanvasBasedWindow failed: ${t.message}")
                reportWebBootFailure(t.message ?: t.toString())
            }
        }
    }
}
